import Layout from '@/layout/layout'

const featureRouter = {
  path: '/corSupPerManege',
  component: Layout,
  redirect: 'noRedirect',
  name: '',
  children: [
    {
      path: 'supPerforpayout',
      component: () => import('@/views/corSupPerManege/supPerforpayout/index'),
      name: '补充绩效发放',
      meta: { title: '补充绩效发放', noCache: true, fixed: true }
    },
        {
      path: 'performanceBil',
      component: () => import('@/views/corSupPerManege/performanceBil/index'),
      name: '补充绩效账单',
      meta: { title: '补充绩效账单', noCache: true, fixed: true }
        },
    {
      path: 'createPerformancePayout',
      component: () => import('@/views/corSupPerManege/supPerforpayout/CreateTask'),
      name: '创建发放任务',
      meta: { title: '创建发放任务', noCache: true }
    },
    {
      path: 'performancePayoutDetail',
      component: () => import('@/views/corSupPerManege/supPerforpayout/TaskDetail'),
      name: '任务详情',
      meta: { title: '任务详情', noCache: true }
    },
  ]
}

export default featureRouter
